import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5cdac793&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdac793",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cdac793')) {
      api.createRecord('5cdac793', component.options)
    } else {
      api.reload('5cdac793', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5cdac793&scoped=true&", function () {
      api.rerender('5cdac793', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/dict/index.vue"
export default component.exports